import { render, staticRenderFns } from "./SoundReductionIndex.vue?vue&type=template&id=1d95f2f6&"
import script from "./SoundReductionIndex.vue?vue&type=script&lang=js&"
export * from "./SoundReductionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports